function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#257226;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#45B82A;}\r\n\t.st3{fill:#C0DF16;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "947.13 644.48 808.65 397.57 720.07 555.52 486.47 972.04 391.35 802.43 246.33 1061 713.53 1061 1180.7 1061"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "713.53 227.96 783.65 352.98 879.02 182.74 486.47 182.74 93.96 182.74 291.03 534.12 416.57 757.45 479.93 644.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "953.67 139 486.47 139 19.27 139 252.87 555.52 391.51 802.14 416.57 757.45 291.03 534.12 93.96 182.74 486.47 182.74 879.02 182.74 783.65 352.98 808.65 397.57 720.07 555.52 486.75 971.55 487 972"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "808.65 397.57 783.65 352.98 713.53 227.96 479.93 644.48 416.57 757.45 391.51 802.14 391.35 802.43 486.47 972.04 486.75 971.55 720.07 555.52"
}));

function SvgVaLogoRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    width: 1200,
    height: 1200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaLogoRgb);
export default __webpack_public_path__ + "static/media/VA_Logo_RGB.c46cdc6e.svg";
export { ForwardRef as ReactComponent };